// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.month-text {
    font-family: "Poppins";
    font-weight: 600;
    color: #000000;
}

.selection-year {
    font-family: "Poppins";
    font-weight: 600;
    border:none;
    font-size: 16px;
}

.selection-year:focus {
    outline: none;
    border: none;
}
`, "",{"version":3,"sources":["webpack://./src/features/order_client_details/components/client_calendar/calendar_header/calendarHeaderStyle.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB","sourcesContent":[".month-text {\n    font-family: \"Poppins\";\n    font-weight: 600;\n    color: #000000;\n}\n\n.selection-year {\n    font-family: \"Poppins\";\n    font-weight: 600;\n    border:none;\n    font-size: 16px;\n}\n\n.selection-year:focus {\n    outline: none;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
